module.exports = __webpack_public_path__ + "img/fuki02_sp.c8e806f4.png";